// extracted by mini-css-extract-plugin
export default {"homeIcon":"Admin_homeIcon__-rRWn"};